import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsCoachingIcon,
    CmpsOpportunityActionGroupModule,
    CmpsOpportunityItemModule,
} from '@cmps/ng-kit';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTabButtonModule,
    CmpsTabsetModule,
} from '@cmps/ng-uikit';

import { CmpsChartModule } from '../../coaching-commitment/chart.module';
import { CmpsEventBoxModule } from '../../coaching-commitment/event-box';
import { CmpsGoalBoxModule } from '../../coaching-commitment/goal-box';
import { CmpsCommonModule } from '../../common/common.module';
import { CmpsSingleDecimalPointModule } from '../../common/pipe/single-decimal-point';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../../route.module';

import { DetailGridComponent } from './detail-grid/detail-grid.component';
import { CoachingDetailPillarThreeComponent } from './pillar-three.component';
import { TranslationIdMap } from './pillar-three.i18n';

@NgModule({
    declarations: [CoachingDetailPillarThreeComponent, DetailGridComponent],
    imports: [
        CmpsButtonModule,
        CmpsChartModule,
        CmpsCoachingIcon,
        CmpsCommonModule,
        CmpsEventBoxModule,
        CmpsGoalBoxModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule,
        CmpsOpportunityActionGroupModule,
        CmpsOpportunityItemModule,
        CmpsSingleDecimalPointModule,
        CmpsTabButtonModule,
        CmpsTabsetModule,
        CommonModule,
        CmpsButtonGroupModule,
    ],
    exports: [CoachingDetailPillarThreeComponent],
})
export class CmpsCoachingDetailPillarThreeModule {}
